import { render, staticRenderFns } from "./chat-body.vue?vue&type=template&id=32812411&scoped=true&"
import script from "./chat-body.vue?vue&type=script&lang=js&"
export * from "./chat-body.vue?vue&type=script&lang=js&"
import style0 from "./chat-body.vue?vue&type=style&index=0&id=32812411&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32812411",
  null
  
)

export default component.exports